export class InvestigationDashboardWidgetEntity {
  public id!: string;
  public dashboardViewTypeId!: string;
  public widgetKey!: string;
  public displayName!: string;
  public displayOrder!: number;
  public widgetType!: string;
  public isVisible!: boolean;
}
